import { render, staticRenderFns } from "./NuevoInicioSesion.vue?vue&type=template&id=32f12329&"
import script from "./NuevoInicioSesion.vue?vue&type=script&lang=js&"
export * from "./NuevoInicioSesion.vue?vue&type=script&lang=js&"
import style0 from "./NuevoInicioSesion.vue?vue&type=style&index=0&id=32f12329&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports